module.exports = __webpack_public_path__ + "img/27.1b54bee7.png";